import React from "react";

const Footer = () => {
  return <div className="absolute-center">Made by Karan Thakkar 💓</div>;
};

export default Footer;
